module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kW6gf"))).then(() => module.bundle.root('ewmtE'));